//Note: don't reuse this.
import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/date-picker.css";
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import momentDate from "../../utils/moment-date";
import { isFalsy } from "../../utils/util";
import { DateInput } from "ra-ui-materialui";
import {Grid} from '@mui/material';
import { datePickerError } from "../Styles";

//Note: don't reuse this.
const CustomDateInput = (props) => {
  const form = useFormContext();
  const values = useWatch();
  const { errors } = useFormState();
  const [date, setDate] = React.useState();
  const {source, defaultValue, validate, isClearable, minDate, maxDate, placeholder} = props;
  
  const handleDateChange = (val) => {
    if (!isFalsy(val)) {
      const dateValue = new Date(val);
      setDate(dateValue);
      form.setValue(source, momentDate(dateValue).format("YYYY-MM-DD"), { shouldValidate: true });
    } else {
      setDate(null);
      form.setValue(source, null, { shouldValidate: true });
    }
  };

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    handleDateChange(defaultValue);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[defaultValue, values.identityVerificationTemplate]);

  return (
    <React.Fragment>
      <Grid display="none">
        <DateInput
          source={source}
          validate={validate}
        />
      </Grid>
      <DatePicker
        id={`${source}-picker`}
        popperPlacement="top"
        wrapperClassName="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-formControl MuiInputBase-sizeSmall"
        onChangeRaw={handleDateChangeRaw}
        onFocus={(ev) => {
          ev.preventDefault()
          ev.target.setAttribute('inputmode', 'none')
        }}
        popperModifiers={{
          flip: {
            behavior: ["top"], // don't allow it to flip to be above
          },
          preventOverflow: {
            enabled: false, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
          },
          hide: {
            enabled: false, // turn off since needs preventOverflow to be enabled
          },
        }}
        selected={date}
        onChange={handleDateChange}
        peekNextMonth
        maxDate={maxDate}
        minDate={minDate}
        showMonthDropdown
        showYearDropdown
        dateFormat="dd/MM/yyyy"
        dropdownMode="select"            
        isClearable={isClearable}
        placeholderText={placeholder ? placeholder : "DD/MM/YYYY"}
      />
      <div style={{...datePickerError, marginTop : '0px' }} id={`${source}-error`}>
        {errors?.[source] && <>Field is required.</>}
      </div>
    </React.Fragment>
  );
};

export default CustomDateInput;


